<style lang="stylus">
    .adbox-alert
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        background rgba(0,0,0,.4)
        z-index 111
        display flex
        justify-content center
        align-items center

        .adbox-alertbox
            height 600px
            max-height 80%
        img
            cursor pointer
        .ad-bg
            height 100%
            object-fit contain

        .close-btn
            position absolute
            right -40px
            top 0px
            cursor pointer
</style>

<template>
    <div class="adbox-alert" v-if="isStore && showAlert">
        <div class="adbox-alertbox" style="position: relative">
            <img class="ad-bg" @click="openLink(activityData.linkUrl)" :src="activityData.imgUrl" alt="" />
            <img class="close-btn" :src="closeBtn" alt="" @click="closeBox(true)" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class ADAlert extends Vue {
        @Prop()
        activityData;
        @Prop()
        activityTime;
        @Prop()
        activityKey;
        @Prop()
        isCheckLog;

        closeBtn: any = require("@/home/assets/img/fullscreen-close.png");
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get isStore() {
            return this.$route.name == "Store" || this.$route.name == "NewPage";
        }
        // 检验是否启用，是否处于活动时间，是否会员屏蔽，是否手动关闭
        get showAlert() {
            return this.$store.state.showAlert && this.isCheckLog;
        }
        setLocal(type) {
            type = `${type}_${this.userInfo.user_id}`;
            let storageItem = JSON.parse(localStorage.getItem(type)) || [];
            storageItem.push(this.activityKey);
            localStorage.setItem(type, JSON.stringify(storageItem));
        }

        openLink(url) {
            let userInfo = "";
            if (this.userInfo && this.userInfo.user_id) {
                userInfo = `&custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
            }
            if (this.internal) {
                let split = /\?/.test(url) ? "&" : "?";
                url = `${url}${split}catalogues=Edrawmaxbuysuccess&source=Pop-ups${userInfo}`;
            } else {
                if (this.isPC) {
                    let split = /\?/.test(url) ? "&" : "?";
                    url = `${url}${split}pid=${this.pid}${userInfo}`;
                    if (this.userInfo.ws_id) {
                        url += `&uid=${this.userInfo.ws_id}`;
                    }
                    const user = JSON.parse((<any>window).userData);
                    if (user.version) {
                        url += `&v=${user.version}`;
                    }
                    (<any>window).$qt.jsCallUploadData &&
                        (<any>window).$qt.jsCallUploadData(
                            JSON.stringify({
                                type: "default",
                                action: "community_button",
                                event: "experience",
                                label: JSON.stringify({
                                    button_type: this.vipStatus + "_pay",
                                }),
                            })
                        );
                }
            }
            if (this.isPC) {
                let win: any = window;
                if (win.$qt && win.$qt.jsCallOpenWebBuyDialog && this.internal) {
                    win.$qt.jsCallOpenWebBuyDialog("&ignorecount=1");
                } else {
                    win.$qt.jsCallOpenUrl(url);
                }
                this.$track("clicksale", "click", "saletype:Pop-ups,source:desktop");
            } else {
                // let newTab = window.open("about:blank");
                // newTab.location.href = url;
                if (this.internal || !url) {
                    this.$openBuyPage();
                } else {
                    window.open(url);
                }
                this.$track("clicksale", "click", "saletype:Pop-ups,source:Web");
            }
            this.closeBox();
        }
        get vipStatus() {
            let role = "";
            if (this.vip) {
                role = this.fuser ? "lifetime" : "nonlifetime";
            } else {
                role = "nonvip";
            }
            return role;
        }
        get showAlertInStore() {
            return this.isStore && this.showAlert;
        }
        @Watch("showAlertInStore")
        watchShowAlertInStore() {
            if (this.showAlertInStore && !this.internal && this.isPC) {
                (<any>window).$qt.jsCallUploadData &&
                    (<any>window).$qt.jsCallUploadData(
                        JSON.stringify({
                            type: "default",
                            action: "community_popup",
                            event: "experience",
                            label: JSON.stringify({
                                popup_type: this.vipStatus + "_popup",
                            }),
                        })
                    );
            }
        }
        closeBox(trigger = false) {
            this.$store.commit("setState", {
                type: "showAlert",
                data: false,
            });
            this.setLocal("alert_ad");
            if (!this.internal && this.isPC && trigger) {
                (<any>window).$qt.jsCallUploadData &&
                    (<any>window).$qt.jsCallUploadData(
                        JSON.stringify({
                            type: "default",
                            action: "community_button",
                            event: "experience",
                            label: JSON.stringify({
                                button_type: this.vipStatus + "_close",
                            }),
                        })
                    );
            }
        }

        checkLog() {
            if (this.$validateLogin(false)) {
                this.$emit("updateActivity");
            } else {
                this.$bus.$on("loginSucc", () => {
                    this.$emit("updateActivity");
                });
            }
        }
        mounted() {
            this.checkLog();
            this.$bus.$on("changeLang", this.checkLog);
        }
        beforeDestroy() {
            this.$bus.$off("loginSucc");
            this.$bus.$off("changeLang");
        }
    }
</script>
